module.exports = __webpack_public_path__ + "static/media/card5_4.ada6961c.png";